module.exports = __webpack_public_path__ + "img/titlebgRed.f78adda3.png";